import React from "react";
import { IonModal } from "@ionic/react";
import Button from "../components/Button";
import './AllergenPopup.scss';
import { downloadAllergenFile } from "../helpers/menuHelpers";

interface AllergenPopupProps {
    show?: boolean;
    close: () => void;
    accept: () => void;
}

function AllergenPopup(props: AllergenPopupProps) {
    return (
        <IonModal
            cssClass='AllergenPopup'
            isOpen={props.show ?? false}
            swipeToClose={true}
            onDidDismiss={props.close}
        >
            <div className='content'>
                <h1>Allergy Information</h1>

                <p
                    className='link'
                    onClick={downloadAllergenFile}
                >
                    View the Allergen Information Guide
                </p>

                <p>We freshly prepare food in a busy kitchen which means that it may contain other allergens than those listed and may not be suitable for you.</p>

                <p><strong>Do you want to continue?</strong></p>

                <div
                    className='button-row'
                >
                    <Button
                        onClick={props.close}
                        expand='block'
                        rounded={true}
                        color='light'
                        size='large'
                    >
                        No
                    </Button>
                    <Button
                        onClick={props.accept}
                        expand='block'
                        rounded={true}
                        size='large'
                    >
                        Yes
                    </Button>
                </div>
            </div>
        </IonModal>
    );
}

export default AllergenPopup;
